import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux'
import { LocaleProvider } from 'antd';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
import {HashRouter as Router,Route} from 'react-router-dom';
import {view as App} from './app/index'
import store from './store'
import registerServiceWorker from './registerServiceWorker';
import './index.css';

ReactDOM.render(
    (
        <Provider store={store}>
            <LocaleProvider locale={zhCN}>
                <Router>
                    <Route path="/" component={App} />
                </Router>
            </LocaleProvider>
        </Provider>
    )
    , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js